import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

export default function ResetPasswordDialog({ open, cancelAction, confirmAction }) {
	return (
		<div>
			<Dialog
				open={open}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{"Ви дійсно бажаєте скинути пароль користувача?"}
				</DialogTitle>
				<DialogContent>{"Будь ласка, впевніться у доступі до email користувача."}</DialogContent>
				<DialogActions>
					<Button onClick={cancelAction}>Ні</Button>
					<Button onClick={confirmAction} autoFocus>
						Так
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
